
import { UK_ROUTES_NEW } from "constants/routes-new";

import { useEffect, useState } from "react";

import Layout from "components/basic/Layout";
import Navigation from "components/basic/Navigation/Navigation";

import RequirementsChecker from "./components/RequirementsChecker";

const ResourcesPage = () => {
    const [resetTrigger, setResetTrigger] = useState(false);
    const [isStartingPage, setIsStartingPage] = useState(true);

    useEffect(() => {
        if (resetTrigger) {
            setTimeout(() => {
                setResetTrigger(false);
            }, 100);
        }
    }, [resetTrigger]);
    return (
        <Layout>
            <Navigation
                items={[{
                    title: "Home",
                    url: UK_ROUTES_NEW.home,
                }, {
                    title: "Making Tax Digital",
                    url: UK_ROUTES_NEW.resources,
                }]}
                handleBack={isStartingPage
                    ? undefined
                    : () => setResetTrigger(true)
                }
            />
            <div className="horizontal-center w100">
                <RequirementsChecker resetTrigger={resetTrigger} setIsStartingPage={setIsStartingPage}/>
            </div>
        </Layout>
    );
};

export default ResourcesPage;
